import React from 'react';
import { Helmet } from 'react-helmet';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../style/main.scss';
import HeroLayout from '../../components/Layouts/HeroLayout';
import Blog from '../../components/Blog/Blog';
export default () => {
  return (
    <HeroLayout metaTitle="Blog" metaDescription='My ideas, thoughts and writings all in one place'>
      <Blog />
    </HeroLayout>
  );
};
